import {makeActionCreator} from '../../redux-toolbelt';

export const setCurrentAddressKey = makeActionCreator<'setCurrentAddressKey', string>('setCurrentAddressKey');
